import { gql } from '@apollo/client';

export const UPDATE_STANDARDIZED_ADDRESS = gql`
  mutation UpdateStandardizedAddress($input: UpdateStandardizedAddressInput!) {
    updateStandardizedAddress(input: $input) {
      success
      errorMessage
    }
  }
`;

export interface UpdateAccessCodeInput {
  id?: string | null;
  codeType: string;
  accessCode?: string | null;
  status: number; // 0-待验证，1-可用，2-不可用
}

export interface UpdateStandardizedAddressInput {
  id: string;
  latitude: number; // 必填
  longitude: number; // 必填
  isBlacklisted?: boolean | null;
  accessCodes?: UpdateAccessCodeInput[] | null;
  deletedCodeIds?: number[] | null; // 要删除的Code ID列表（前端明确标记）
}

export interface UpdateStandardizedAddressResponse {
  updateStandardizedAddress: {
    success: boolean;
    errorMessage: string | null;
  };
}

